export default function Container({children}) {
    return (
        <div className={"shadow-sm p-3 m-3 border bg-white"}>
            {children}
        </div>
    );
};